import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/core/config_company'
export default {
  namespaced: true,
  state: {
    dataItem: {
      id: null,
      title: null,
      tax_admin: null,
      tax_no: null,
      addresses: null,
      id_countries: null,
      id_cities: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        title: null,
        tax_admin: null,
        tax_no: null,
        addresses: null,
        id_countries: null,
        id_cities: null,
      }
    },
  },
  actions: {
    getDataItem({ commit }, params) {
      const data = JSON.stringify({
        where: {
          'config_company.id': params.id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
